import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {BronteSistersCutouts} from "../layout/BronteSistersCutouts";
import {
    BronteSistersStoryLayout_scene1Yadina,
    BronteSistersStoryLayout_scene2Xavier,
    BronteSistersStoryLayout_scene3Location,
    BronteSistersStoryLayout_scene4Floor,
    BronteSistersStoryLayout_scene5Bard,
    BronteSistersStoryLayout_scene6Rescue,
} from "../layout/BronteSistersStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {StoryModel} from "./StoryModel";

export const StoryBronteSisters: StoryModel<BronteSistersSceneId, BronteSistersSlotId> = {
    storyId: BookId.Bronte,
    storyIndex: 1,
    promptVO: "bro_brad_st_{index}",
    optionVO: "bro_brad_st_{index}",
    introVO: ["bro_xavier_in_001", "bro_yadina_in_001", "bro_brad_in_001"],
    outroVO: ["bro_yadina_out_001", "bro_xavier_out_001", "bro_brad_out_001"],
    outroImage: "bro-story-image",
    cutouts: new CutoutData(BronteSistersCutouts),
    scenes: [
        {
            sceneId: "yadina",
            sfx: "sc_028_XR111B_070_Quick Build into Crescendo",
            cc: "One rainy day, Yadina pretended to be {option-yadina.}",
            voIndex: 1,
            options: [
                {optionId: "ringmaster", cc: "a Ringmaster", icon: "bro-y-costume-0-buttonimg", voIndex: 2},
                {optionId: "bug", cc: "a Bug", icon: "bro-y-costume-1-buttonimg", voIndex: 3},
                {optionId: "astronaut", cc: "an Astronaut", icon: "bro-y-costume-2-buttonimg", voIndex: 4},
                {optionId: "diver", cc: "a Diver", icon: "bro-y-costume-3-buttonimg", voIndex: 5},
            ],
            layout: BronteSistersStoryLayout_scene1Yadina,
        },
        {
            sceneId: "xavier",
            sfx: "sc_073_quicktada",
            cc: "And Xavier pretended to be {option-xavier.}",
            voIndex: 6,
            options: [
                {optionId: "clown", cc: "a Clown", icon: "bro-x-costume-0-buttonimg", voIndex: 7},
                {optionId: "pirate", cc: "a Pirate", icon: "bro-x-costume-3-buttonimg", voIndex: 8},
                {optionId: "caterpillar", cc: "a Caterpillar", icon: "bro-x-costume-1-buttonimg", voIndex: 9},
                {optionId: "baseball", cc: "a Baseball Player", icon: "bro-x-costume-2-buttonimg", optionVO: "bro_brad_st_010_alt"},
            ],
            layout: BronteSistersStoryLayout_scene2Xavier,
        },
        {
            sceneId: "location",
            sfx: "sc_011_XR102A_018_Triumphant Music Xavier",
            cc: "Yadina and Xavier pretended they were inside {option-location.}",
            voIndex: 11,
            options: [
                {optionId: "library", cc: "a Library", icon: "bro-bg-library-buttonimg", iconPosition: "center", voIndex: 12},
                {optionId: "castle", cc: "a Castle", icon: "bro-bg-castle-buttonimg", iconPosition: "center", voIndex: 13},
                {optionId: "garden", cc: "a Garden", icon: "bro-bg-garden-buttonimg", iconPosition: "center", voIndex: 14},
                {optionId: "pizza", cc: "a Pizza Palace", icon: "bro-bg-pizza-buttonimg", iconPosition: "center", voIndex: 15},
            ],
            layout: BronteSistersStoryLayout_scene3Location,
        },
        {
            sceneId: "floor",
            cc: "When suddenly, they pretended the floor turned into {option-floor!}",
            voIndex: 16,
            options: [
                {optionId: "quicksand", cc: "Quicksand", icon: "bro-floor-quicksand-buttonimg", sfx: "sc_039_102A_072_Upward Chimes", voIndex: 17},
                {optionId: "lava", cc: "Lava", icon: "bro-floor-lava-buttonimg", sfx: "sc_033_XR113A_054_Sizzling", voIndex: 18},
                {optionId: "pudding", cc: "Pudding", icon: "bro-floor-pudding-buttonimg", sfx: "sc_056_XR113B_099_Flat Bass-y Horns", voIndex: 19},
                {optionId: "ice", cc: "Ice", icon: "bro-floor-ice-buttonimg", sfx: "sc_024_XR101B_005_Water Freeze No Chime", voIndex: 20},
            ],
            layout: BronteSistersStoryLayout_scene4Floor,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_009"),
            },
        },
        {
            sceneId: "brad",
            sfx: "sc_029_XR111B_072_Triumphant Build",
            cc: "So then, Brad pretended to rescue his friends as {option-brad!}",
            voIndex: 21,
            options: [
                {optionId: "bikeman", cc: "Bike Man", icon: "bro-b-costume-0-buttonimg", voIndex: 22},
                {optionId: "butterfly", cc: "a Butterfly", icon: "bro-b-costume-1-buttonimg", optionVO: "bro_brad_st_023_alt"},
                {optionId: "bradman", cc: "Bradman", icon: "bro-b-costume-2-buttonimg", optionVO: "bro_brad_st_024_alt"},
                {optionId: "radbrad", cc: "Rad Brad", icon: "bro-b-costume-3-buttonimg", optionVO: "bro_brad_st_025_alt"},
            ],
            layout: BronteSistersStoryLayout_scene5Bard,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "re_yadina_009"),
            },
        },
        {
            sceneId: "rescue",
            sfx: "sc_042_XR102A_080_Triumphant Orchestra",
            cc: "Xavier and Yadina were proud to have such a brave friend as they climbed aboard Brad's rescue {option-rescue!}",
            voIndex: 26,
            options: [
                {optionId: "balloon", cc: "Balloon", icon: "bro-balloon-buttonimg", iconPosition: {x: 0, y: -30}, voIndex: 27},
                {optionId: "boat", cc: "Boat", icon: "bro-boat-buttonimg", iconPosition: {x: 25, y: -30}, voIndex: 28},
                {optionId: "dinosaur", cc: "Dinosaur", icon: "bro-dino-buttonimg", optionVO: "bro_brad_st_029_alt"},
                {optionId: "bicycle", cc: "Bicycle", icon: "bro-bicycle-buttonimg", iconPosition: "center", optionVO: "bro_brad_st_030_alt"},
            ],
            layout: BronteSistersStoryLayout_scene6Rescue,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Xavier, "re_xavier_010", true),
                    new SceneInjectionCharacterReaction(CharacterType.Brad, "bro_brad_st_031_alt"),
                ),
            },
        },
    ],
};

export type BronteSistersSceneId =
    "yadina"
    | "xavier"
    | "location"
    | "floor"
    | "brad"
    | "rescue";
export type BronteSistersSlotId = "yadina" | "xavier" | "location" | "floor" | "brad" | "rescue";
